<template>
  <div>
    <home-carousel />
    <div
      class="knews"
      :class="{ 'game-type':
        brand.showSearch || brand.showProvider ||
        currentGameCategory || currentGameType ||
        activeFilter === 'favorites' }"
    >
      <div class="news-img">
        <img :src="getThemeImagePath('bullhorn.svg')" alt="">
      </div>

      <div
        ref="marqueeContainer"
        class="news-body"
        @mouseenter="stopMarquee"
        @mouseleave="startMarquee"
      >
        <!-- eslint-disable-next-line -->
        <a v-for="(item, key) in marqueeDetails.filter(item => item.catalog === '')" :key="key" :style="marqueeStyle" @click="goNewsPage(key+1)" v-html="item.title"/>
      </div>
      <a class="news-more" @click="goNewsPage('')">{{ $t('Bao.news_more') }}<i class="fa-solid fa-chevron-right" /></a>
    </div>

    <search-game v-if="isMobile()" id="search_game_modal_mb" :all-game="allGame" />
    <search-provider v-if="isMobile()" id="provider_game_modal_mb" @change-provider="changeGameProvider" />

    <div class="main-max-width">
      <div class="game-quick-link">
        <!-- 中間區塊-新事件 -->
        <div
          class="new-events"
          :class="{ 'game-type':
            brand.showSearch || brand.showProvider ||
            currentGameCategory || currentGameType ||
            activeFilter === 'favorites' }"
        >
          <div class="game-title">
            <p>{{ $t('Bao.new_event') }}</p>
          </div>
          <div class="new-events-div">
            <div
              ref="carousel-event"
              class="list"
            >
              <div
                v-for="item in brandImage"
                :key="item.id"
                class="new-swiper-slide"
              >
                <a @click.prevent="handleClick(item.link,item.open_type)">
                  <img :src="item.image" alt="">
                </a>
              </div>
            </div>
            <div class="game-button-alpha">
              <div
                class="game-next fa-solid fa-angle-left "
                :class="{ disabled: !canScrollPrev('event') }"
                @click=" prev('event')"
              />
              <div
                class="game-prev fa-solid fa-angle-right "
                :class="{ disabled: !canScrollNext('event') }"
                @click=" next('event')"
              />
            </div>
          </div>
        </div>
        <search-provider v-if="!isMobile()" id="provider_game_modal" @change-provider="changeGameProvider" />
        <search-game v-if="!isMobile()" id="search_game_modal" :all-game="allGame" />

        <!-- 預設或選擇 type、provider 的遊戲 -->
        <div
          v-if="!currentGameCategory && (isFirstRender || activeFilter === 'others')"
          class="slick-list "
        >
          <div ref="gameFilterContainer" class="slick-div">
            <div
              v-for="(type, key) in gameType"
              :key="key"
              class="games-type"
              :class="{ 'active': isGameTypeActive(type) }"
              @click.stop="changeGameType(type)"
            >
              <img class="main-games-btn" :src="type.image_pc_icon" :alt="type.name">
              <p>{{ type.name }}</p>
            </div>
          </div>
        </div>
        <!-- 點擊 All -->
        <VueSlickCarousel
          v-if="!isFirstRender && currentGameCategory || activeFilter === 'favorites' &&
            catagoryList && catagoryList.length > 0"
          ref="slickCarousel"
          :key="carouselKey"
          class="slider provider-container list"
          v-bind="slick_setting"
        >
          <div
            v-for="(item, key) in catagoryList"
            :key="key"
            ref="gameCategory"
            :class="{ active: isGameCategoryActive(item) }"
            @click="changeGameCategory(item)"
          >
            <a>
              <img :src="item.image_banner" alt="">
            </a>
          </div>
          <template #prevArrow="">
            <i class="jp-slick-arrow">
              <img :src="getThemeImagePath('home-arrow-left.png')" alt=""></i>
          </template>
          <template #nextArrow="">
            <i class="jp-slick-arrow">
              <img :src="getThemeImagePath('home-arrow-right.png')" alt=""></i>
          </template>
        </VueSlickCarousel>

        <div ref="gameFilter" class="lobby-search-bar" :class="{ 'game-type': !isFirstRender }">
          <div v-if="!isFirstRender" class="back-icon" @click="handleBack">
            <a><i class="fa-solid fa-chevron-left fa-lg" /></a>
          </div>
          <ul>
            <li @click="showSearchProvider()">
              <i>
                <img :src="getThemeImagePath('icon-filter.png')" alt="">
              </i>
              <span>{{ $t("Bao.provider_name") }}</span>
            </li>
            <li class="search-box" @click="showSearchGame()">
              <div class="slot-animation">
                <span>{{ $t('Bao.search_games_text1') }}</span>
                <span id="workHour" class="font-weight-bold work_hour font-xl">0</span>
                <span>{{ $t('Bao.search_games_text2') }}</span>
              </div>
            </li>
          </ul>
        </div>
        <template v-if="isFirstRender">
          <div v-for="item in catagoryGame" :key="item.id" class="game-section">
            <div class="game-title">
              <p>{{ item.name }}</p>
              <div class="game-bn">
                <i class="button-icon" @click="showAllGame(item)">All</i>
              </div>
            </div>
            <div :key="componentKey" class="game-card-list">
              <div
                :ref="item.id === -1 ? 'carousel-fav' : `carousel-${item.id}`"
                class="game-card-list-div"
              >
                <div
                  v-for="game in allCategoryGame[item.id]"
                  :key="game.id"
                  class="game-swiper-slide"
                >
                  <div
                    :class="{ 'active': hover === game.id }"
                    class="game-card"
                    :data-category="item.id"
                    @click="token ? handleLaunchGame(game) : hover = game.id"
                    @mouseenter="!isMobile() && !token && (hover = game.id)"
                    @mouseleave="!isMobile() && !token && (hover = null)"
                  >
                    <div v-if="game.brand_game_category_id.includes('HOT')" class="game-info-icon-hot">
                      HOT
                    </div>
                    <div v-if="game.brand_game_category_id.includes('NEW')" class="game-info-icon-new">
                      NEW
                    </div>
                    <div class="game-card-name">
                      <div class="game-tx">
                        <div class="game-name name-tex">
                          {{ game.name }}
                        </div>
                        <div class="game-provider-tx">
                          {{ game.game_provider_name }}
                        </div>
                        <span class="game-rtp">
                          <template v-if="game.rtp !== -1">
                            <p>{{ $t("Bao.rtp") }}：</p>
                            <p>{{ (game.rtp * 100).toFixed(2) }}%</p>
                          </template>
                        </span>
                        <div class="game-provider">
                          <img :src="getProviderImage(game.game_provider_id)" alt="">
                        </div>
                      </div>
                      <div class="game-info">
                        <i class="game-info-icon" />
                        <i
                          v-if="token"
                          class="game-info-icon-heart-show"
                          :class="{ active:game.isFavorite }"
                          @click.stop="handleFavoriteGame(game)"
                        />
                        <i
                          v-if="game.brand_game_category_id.includes('NO BONUS')"
                          class="game-info-icon-nobonus-show"
                        />
                      </div>
                    </div>
                    <div class="game-card-image">
                      <div class="img-mask" />
                      <d-img :src="game" :alt="game.name" />
                    </div>

                    <div class="game-card-info">
                      <div class="game-info-bn">
                        <button @click.stop="handleLaunchGame(game)">
                          {{ $t("Bao.play_game_now") }}
                        </button>
                        <button v-if="game.demo_url" @click.stop="openDemoGame(game)">
                          {{ $t('Bao.demo') }}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="game-button-alpha">
                  <div
                    class="game-next fa-solid fa-angle-left "
                    :class="{ disabled: !canScrollPrev(item.id) }"
                    @click=" prev(item.id)"
                  />
                  <div
                    class="game-prev fa-solid fa-angle-right "
                    :class="{ disabled: !canScrollNext(item.id) }"
                    @click=" next(item.id)"
                  />
                </div>
              </div>
            </div>
          </div>
          <showoff-gamebets />
        </template>
        <template v-else>
          <div class="game-main">
            <div class="game-section">
              <div class="game-title">
                <p v-if="activeFilter === 'favorites'">
                  {{ $t('Bao.my_favorite') }}
                </p>
                <p v-else-if="currentGameCategory">
                  {{ currentGameCategory.name }}
                </p>
                <p v-else-if="currentGameProvider">
                  {{ currentGameProvider.name }}
                </p>
                <p v-else-if="currentGameType">
                  {{ currentGameType.name }}
                </p>
              </div>
              <div class="game-card-list game-type">
                <div
                  v-for="game in selectedCategoryGame"
                  :key="game.id"
                  class="game-card game-type"
                  :class="{ 'active': hover === game.id }"
                  @click="token ? handleLaunchGame(game) : hover = game.id"
                  @mouseenter="!isMobile() && !token && (hover = game.id)"
                  @mouseleave="!isMobile() && !token && (hover = null)"
                >
                  <div v-if="game.brand_game_category_id.includes('HOT')" class="game-info-icon-hot">
                    HOT
                  </div>
                  <div v-if="game.brand_game_category_id.includes('NEW')" class="game-info-icon-new">
                    NEW
                  </div>
                  <div class="game-card-name">
                    <div class="game-tx">
                      <div class="game-name name-tex">
                        {{ game.name }}
                      </div>
                      <div class="game-provider-tx">
                        {{ game.game_provider_name }}
                      </div>
                      <span class="game-rtp">
                        <template v-if="game.rtp !== -1">
                          <p>{{ $t("Bao.rtp") }}：</p>
                          <p>{{ (game.rtp * 100).toFixed(2) }}%</p>
                        </template>
                      </span>
                      <div class="game-provider">
                        <img :src="getProviderImage(game.game_provider_id)" alt="">
                      </div>
                    </div>
                    <div class="game-info">
                      <i class="game-info-icon" />
                      <i
                        v-if="token"
                        class="game-info-icon-heart-show"
                        :class="{ active:game.isFavorite }"
                        @click.stop="handleFavoriteGame(game)"
                      />
                      <i
                        v-if="game.brand_game_category_id.includes('NO BONUS')"
                        class="game-info-icon-nobonus-show"
                      />
                    </div>
                  </div>
                  <div class="game-card-image">
                    <div class="img-mask" />
                    <d-img :src="game" :alt="game.name" />
                  </div>

                  <div class="game-card-info">
                    <div class="game-info-bn">
                      <button @click.stop="handleLaunchGame(game)">
                        {{ $t("Bao.play_game_now") }}
                      </button>
                      <button v-if="game.demo_url" @click.stop="openDemoGame(game)">
                        {{ $t('Bao.demo') }}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <scroll-loader v-if="activeFilter === 'others'" :loader-method="getIndexGameList" :loader-disable="!enableAutoLoad" />
          </div>
        </template>
      </div>
    </div>
    <iframe-game v-if="gameUrlFromStore" :all-game="allGame" :text="gameTextTitle" />
    <performance-modal :is-active="gameModalOpen" />  <!-- 遊戲開啟前文案 每日一次 -->
  </div>
</template>
<script>
import VueSlickCarousel from 'vue-slick-carousel'
import 'vue-slick-carousel/dist/vue-slick-carousel.css'
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'
import { getGames, getGameList, getProviderNum, getGameNum } from '@/api/game'
import { addFavoriteGame, removeFavoriteGame, updateToken } from '@/api/user'
import { getMarqueeDetail } from '@/api/brand'
import { getEventDetail } from '@/api/event'
import { showToast, detectMob, getThemeImagePath, showAd, isCrossDay, initializeCountUp, updateCountUp } from '@/utils/tool'
import { gameStart, gameEnd } from '@/utils/games'
import dImg from '@/components/dynamicImg'
import homeCarousel from '@/components/homeCarousel'
import performanceModal from '@/components/modal/performanceModal'
import iframeGame from '@/components/modal/iframeGame'
import searchProvider from '@/components/popup-box/searchProvider'
import searchGame from '@/components/popup-box/searchGame'
import { mapMutations } from 'vuex'
import ScrollLoader from 'vue-scroll-loader/src/components/Scroll-Loader'
import showoffGamebets from '@/components/showoffGamebets'

export default {
  name: 'Index',
  components: {
    VueSlickCarousel,
    performanceModal,
    dImg,
    homeCarousel,
    searchProvider,
    searchGame,
    iframeGame,
    ScrollLoader,
    showoffGamebets
  },
  data() {
    return {
      navigationHistory: [],
      allGame: [],
      selectedCategoryGame: [],
      allCategoryGame: [],
      favoriteGames: [],
      favoriteAll: [],
      marqueeDetails: [],
      positionX: 100,
      speed: 0.8,
      isRunning: false,
      animationFrameId: null,
      page: 1,
      page_size: 100,
      isFirstRender: true,
      gameTextTitle: '',
      workHourVal: 0,
      carouselKey: 0, // 初始 key 值
      slick_setting: {
        draggable: true,
        infinite: false,
        dots: false,
        initialSlide: 0,
        focusOnSelect: false,
        slidesToShow: 8,
        lazyLoad: 'ondemand',
        responsive: [
          {
            breakpoint: 1800,
            settings: {
              slidesToShow: 8,
              slidesToScroll: 1
            }
          },
          {
            breakpoint: 1440,
            settings: {
              slidesToShow: 6,
              slidesToScroll: 1
            }
          },
          {
            breakpoint: 1200,
            settings: {
              slidesToShow: 5,
              slidesToScroll: 1
            }
          },
          {
            breakpoint: 800,
            settings: {
              slidesToShow: 4,
              slidesToScroll: 1
            }
          },
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1
            }
          }
        ]
      },
      hover: null,
      catagoryGame: [],
      catagoryList: [],
      allType: [],
      allCategory: [],
      allProvider: [],
      allGameData: [],
      isFromBack: false,
      cardWidth: 193,
      actualGap: 16,
      componentKey: 0,
      isGameCategoryReady: false,
      isGameTypeReady: false,
      enableAutoLoad: true,
      loading: false
    }
  },
  metaInfo() {
    const isProduction = process.env.VUE_APP_ENV === 'production'
    const targetGameType = isProduction ? 13 : 12

    if (this.currentGameType && this.currentGameType.game_type === targetGameType) {
      const title = '勝WINのアカウント連携方法 | 簡単ステップで連携完了'
      const description = '勝WINのアカウント連携方法を詳しく解説。簡単なステップで連携を完了し、スムーズにゲームをお楽しみいただけます。'
      const keywords = '勝WIN, アカウント連携, 連携方法'

      return {
        title: title,
        meta: [
          {
            name: 'description',
            content: description
          },
          {
            name: 'keywords',
            content: keywords
          }
        ]
      }
    }

    return {
      title: this.app.metaInfo.title
    }
  },
  computed: {
    token() {
      return this.$store.getters.token
    },
    user() {
      return this.$store.state.user
    },
    brand() {
      return this.$store.state.brand
    },
    gameType() {
      return this.$store.getters.gameType
    },
    brandImage() {
      const brandImage = this.$store.state.brand.brandImage.img_event
      return Array.isArray(brandImage)
        ? [...brandImage].sort((a, b) => a.sort - b.sort)
        : []
    },
    gameCategory() {
      const category = Array.isArray(this.$store.getters.gameCategory)
        ? this.$store.getters.gameCategory.slice()
        : []

      return [...category].sort((a, b) => a.sorting - b.sorting)
    },
    gameProvider() {
      return this.$store.state.game.gameProvider
    },
    activeFilter() {
      return this.user.activeFilter
    },
    app() {
      return this.$store.state.app
    },
    gameModalOpen() {
      return this.app.isModalActive
    },
    gameUrlFromStore() {
      return this.app.gameUrl
    },
    currentGameCategory() {
      return this.user.currentGameCategory
    },
    currentGameType() {
      return this.user.currentGameType
    },
    currentGameProvider() {
      return this.user.currentGameProvider
    },
    marqueeStyle() {
      return {
        transform: `translateX(${this.positionX}px)`
      }
    },
    favoriteGamesId() {
      return this.user.favoriteGame || []
    }
  },
  watch: {
    'gameCategory': {
      immediate: true,
      handler(newVal) {
        if (newVal) {
          this.isGameCategoryReady = true
          this.allCategory = newVal
          this.checkAndInitialize()
        }
      }
    },
    'gameType': {
      immediate: true,
      handler(newVal) {
        if (newVal) {
          this.isGameTypeReady = true
          this.allType = newVal
          this.checkAndInitialize()
        }
      }
    },
    'activeFilter'(to) {
      if (to === 'others' &&
      !this.currentGameType && !this.currentGameCategory && !this.currentGameProvider) {
        this.initIndex()
      } else if (to === 'favorites') {
        this.isFirstRender = false
        this.updateFavoriteAll(this.favoriteGamesId)

        this.$nextTick(() => {
          this.gameScroll('gameCategory', 'gameCategory', 20, 135)
        })
      }
    },
    'currentGameCategory'(to) {
      if (to !== null) {
        this.isFirstRender = false
        this.$store.commit('SET_ACTIVE_FILTER', 'others')
        this.getGameNum()
        this.getCatagoryList()
        this.queryGame()

        this.$nextTick(() => {
          setTimeout(() => {
            this.clearQuery()
            this.gameScroll('gameCategory', 'gameCategory', 20, 180)
          }, 300)
        })
      } else if (to === null && !this.currentGameType && !this.currentGameProvider) {
        if (this.activeFilter !== 'favorites') {
          this.initIndex()
        }
      }
    },
    'currentGameType'(to) {
      if (to !== null) {
        this.isFirstRender = false
        this.$store.commit('SET_ACTIVE_FILTER', 'others')
        this.queryGame()
        this.refreshProvider(to.game_type)
        this.getProviderNum(to.game_type)

        this.$nextTick(() => {
          setTimeout(() => {
            this.clearQuery()
            this.gameScroll('gameFilterContainer', 'gameFilter', 100, 162)
          }, 300)
        })
      } else if (to === null && !this.currentGameCategory) {
        if (this.activeFilter !== 'favorites') {
          this.initIndex()
        }
      }
    },
    'currentGameProvider'(to) {
      if (to !== null) {
        this.isFirstRender = false
        this.queryGame()
        this.getGameNum()

        this.$nextTick(() => {
          setTimeout(() => {
            this.clearQuery()
            this.gameScroll('gameFilterContainer', 'gameFilter', 100, 162)
          }, 300)
        })
      } else {
        if (this.activeFilter !== 'favorites' && !this.currentGameCategory && !this.currentGameType) {
          this.initIndex()
        }
      }
    },
    'gameUrlFromStore'(newVal, oldVal) {
      if (!newVal) {
        gameEnd(this.app.inGameId)

        if (oldVal) {
          this.isInit()
        }
      }
    },
    'token'(newVal, oldVal) {
      this.initIndex()
      this.hover = null
    }
  },

  beforeDestroy() {
    this.stopMarquee()
  },
  created() {
    if (this.user.isFromChampionship && !this.token) {
      this.$store.commit('SET_LOGIN_OPEN', true)
    }
    this.$store.commit('SET_CHAMPIONSHIP', false)
    if (this.user.isFromPromotion && !this.token) {
      this.$store.commit('SET_LOGIN_OPEN', true)
    }
    this.$store.commit('SET_PROMOTION', false)

    if (localStorage.getItem('fromSelfRestraint')) {
      this.$store.commit('SET_LOGIN_OPEN', true)
      localStorage.removeItem('fromSelfRestraint')
    }

    getMarqueeDetail().then(response => {
      this.marqueeDetails = response.data.data
      this.$store.commit('SET_MARQUEE_DETAIL', this.marqueeDetails)

      if (this.user.newsId) {
        getEventDetail(this.user.newsId)
          .then(response => {
            const newsCount = response.data.data.reward.count
            const gameText = this.marqueeDetails.find(item => {
              return item.catalog === 'manual_first_deposit_v2'
            })

            if (newsCount > 0 && gameText) {
              this.gameTextTitle = gameText.title
            }
          })
      }

      this.$nextTick(() => {
        this.startMarquee()
      })
    })

    this.checkTokenExpiration()
    this.getAllGameForSearch()
  },
  mounted() {
    this.initializeCountUp()
  },
  methods: {
    checkAndInitialize() {
      if (this.isGameCategoryReady && this.isGameTypeReady) {
        this.isInit()
      }
    },
    isInit() {
      // 從別的頁面回到首頁
      if (this.currentGameCategory) {
        this.isFirstRender = false
        this.$store.commit('SET_ACTIVE_FILTER', 'others')
        this.getCatagoryList()
        this.queryGame()

        this.$nextTick(() => {
          setTimeout(() => {
            this.gameScroll('gameCategory', 'gameCategory', 20, 180)
          }, 300)
        })
      } else if (this.currentGameType || this.currentGameProvider) {
        if (localStorage.getItem('onlyOneGame')) {
          this.$store.commit('SET_CURRENT_GAME_TYPE', null)
          localStorage.removeItem('onlyOneGame')
        } else {
          this.isFirstRender = false
          this.queryGame()

          if (this.currentGameType) {
            this.refreshProvider(this.currentGameType.game_type)
            this.getProviderNum(this.currentGameType.game_type)
          }

          this.$nextTick(() => {
            setTimeout(() => {
              this.gameScroll('gameFilterContainer', 'gameFilter', 100, 162)
            }, 300)
          })
        }

        this.$store.commit('SET_ACTIVE_FILTER', 'others')
      } else if (this.activeFilter === 'favorites') {
        this.isFirstRender = false

        this.getCatagoryList()
        this.updateFavoriteAll(this.favoriteGamesId)

        this.$nextTick(() => {
          this.gameScroll('gameCategory', 'gameCategory', 20, 135)
        })
      } else {
        this.initIndex()
      }
    },
    getAllProvider() {
      this.allProvider = []

      for (const item of this.allType) {
        item.providers.forEach(provider => {
          this.allProvider.push(provider)
        })
      }

      this.allProvider.sort((a, b) => a.sort - b.sort)
      this.$store.commit('SET_GAME_PROVIDER', this.allProvider)
    },
    handleQuery(queryKey, storeKey, source) {
      const queryValue = Number(this.$route.query[queryKey])
      const item = source.find(item => item.id === queryValue || item.game_type === queryValue)

      if (item) {
        this.$store.commit(storeKey, item)
      } else {
        this.clearQuery()
        this.initIndex()
      }
    },
    setQueryObj(query) {
      if (query.category) {
        this.handleQuery('category', 'SET_CURRENT_GAME_CATEGORY', this.$store.state.game.gameCategory)
      } else if (query.type) {
        this.handleQuery('type', 'SET_CURRENT_GAME_TYPE', this.allType)
      } else if (query.provider_id) {
        this.handleQuery('provider_id', 'SET_CURRENT_GAME_PROVIDER', this.allProvider)
      } else if (query.share_code) {
        this.$store.commit('SET_REGISTER_OPEN', true)
      } else {
        this.clearQuery()
        this.initIndex()
      }
    },
    initIndex() {
      this.getAllProvider()

      const query = this.$route.query
      const hasParams = Object.keys(query).length > 0
      if (hasParams) {
        this.isFirstRender = false
        this.setQueryObj(query)
        return
      }

      this.isFirstRender = true
      this.navigationHistory = []
      this.isFromBack = false

      this.$store.commit('SET_SHOW_RESEARCH', false)
      this.$store.commit('SET_SHOW_PROVIDER', false)

      this.getIndexGameList()

      this.$store.commit('SET_ACTIVE_FILTER', 'others')
      this.$store.commit('SET_CURRENT_GAME_CATEGORY', null)
      this.$store.commit('SET_CURRENT_GAME_TYPE', null)
      this.$store.commit('SET_CURRENT_GAME_PROVIDER', null)

      window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'smooth'
      })

      this.resetScrollToStart('-1')
      this.allCategory.forEach(category => {
        this.resetScrollToStart(category.id)
      })

      this.componentKey += 1
    },
    handleBack() {
      if (this.navigationHistory.length > 0) {
        this.navigationHistory.pop()
        this.isFromBack = true

        const lastHistory = this.navigationHistory[this.navigationHistory.length - 1]
        if (!lastHistory) {
          this.initIndex()
        } else if (lastHistory.attribute === 'category') {
          this.$store.commit('SET_CURRENT_GAME_CATEGORY', lastHistory)
          this.$store.commit('SET_CURRENT_GAME_TYPE', null)
          this.$store.commit('SET_CURRENT_GAME_PROVIDER', null)
        } else if (lastHistory.attribute === 'type') {
          this.$store.commit('SET_CURRENT_GAME_TYPE', lastHistory)
          this.$store.commit('SET_CURRENT_GAME_CATEGORY', null)
        } else if (lastHistory.attribute === 'provider') {
          this.$store.commit('SET_CURRENT_GAME_PROVIDER', lastHistory)
          this.$store.commit('SET_CURRENT_GAME_CATEGORY', null)
        } else {
          this.$store.commit('SET_ACTIVE_FILTER', 'favorites')
          this.$store.commit('SET_CURRENT_GAME_CATEGORY', null)
          this.$store.commit('SET_CURRENT_GAME_TYPE', null)
          this.$store.commit('SET_CURRENT_GAME_PROVIDER', null)
        }
      } else {
        if (this.activeFilter !== 'favorites') {
          this.initIndex()
        }
      }
    },
    queryGame() {
      this.allGameData = []
      this.selectedCategoryGame = []
      this.page = 1
      this.enableAutoLoad = true
      this.hover = null
      this.getIndexGameList()
    },
    async getIndexGameList() {
      this.$meta().refresh()

      if (!this.isFirstRender) {
        if (this.loading) return
        this.loading = true

        let id = ''
        let queryObj = {}

        if (this.currentGameCategory) {
          id = this.currentGameCategory.id
          queryObj =
          {
            category: id,
            page: this.page,
            page_size: this.page_size
          }

          if (this.isFromBack) {
            this.isFromBack = false
          } else {
            this.navigationHistory.push(this.currentGameCategory)
          }
        } else if (this.currentGameProvider) {
          id = this.currentGameProvider.id
          queryObj =
          {
            provider_id: id,
            page: this.page,
            page_size: this.page_size
          }

          if (this.isFromBack) {
            this.isFromBack = false
          } else {
            this.navigationHistory.push(this.currentGameProvider)
          }
        } else if (this.currentGameType) {
          id = this.currentGameType.game_type
          queryObj =
          {
            type: id,
            page: this.page,
            page_size: this.page_size
          }
          if (this.isFromBack) {
            this.isFromBack = false
          } else {
            this.navigationHistory.push(this.currentGameType)
          }
        }

        const gamesData = await this.fetchGamesFromAPI(queryObj)
        if (gamesData.length === 0) {
          return
        }

        this.allGameData = [...this.allGameData, ...gamesData.list]

        const processedGames = this.sortCategoryGames(gamesData.list)
        this.selectedCategoryGame = [...this.selectedCategoryGame, ...processedGames]

        if (processedGames.length === 1 && this.token) {
          localStorage.setItem('onlyOneGame', true)

          this.handleLaunchGame(processedGames[0])
          this.enableAutoLoad = false
        } else if (this.allGameData.length >= gamesData.page_info.total_count) {
          this.enableAutoLoad = false
        } else {
          this.page += 1
          this.enableAutoLoad = true
        }

        this.loading = false
      } else {
        this.getGameNum()

        try {
          this.$store.commit('SET_LOADING_COUNT_PLUS', true)

          const categories = this.allCategory
          if (!categories || !Array.isArray(categories) || categories.length === 0) {
            console.error('無有效的遊戲分類資料')
            return
          }

          this.getCatagoryGame()

          const results = await this.fetchAllCategoryGames(categories)

          // 將結果整理成物件形式
          const groupedGames = {}
          results.forEach(result => {
            groupedGames[result.categoryId] = result.games
          })

          if (this.favoriteGamesId.length > 0) {
            await this.updateFavoriteAll(this.favoriteGamesId)

            const groupedFavoriteGames = {
              '-1': this.favoriteAll
            }

            this.allCategoryGame = {
              ...this.sortAllCategoryGames(groupedGames),
              ...groupedFavoriteGames

            }
            this.getCatagoryList()
          } else {
            this.allCategoryGame = groupedGames
          }
        } catch (error) {
          console.error('獲取遊戲資料錯誤:', error)
        } finally {
          this.$store.commit('SET_LOADING_COUNT_ZERO', true)
        }
      }
    },
    sortCategoryGames(gamesData) {
      return gamesData
        .filter(game => game.status === 1 && game.is_show === '1')
        .sort(this.sortGames)
        .map(game => {
          return {
            ...game,
            isFavorite: this.isGameFavorite(game.id)
          }
        })
    },
    sortAllCategoryGames(gamesObj) {
      const result = {}
      Object.keys(gamesObj).forEach(categoryId => {
        result[categoryId] = gamesObj[categoryId]
          .filter(game => game.status === 1 && game.is_show === '1')
          .sort(this.sortGames)
          .map(game => {
            return {
              ...game,
              isFavorite: this.isGameFavorite(game.id)
            }
          })
      })
      return result
    },
    sortGames(a, b) {
      const aHasNew = a.brand_game_category_id.includes('NEW')
      const bHasNew = b.brand_game_category_id.includes('NEW')
      const aHasHot = a.brand_game_category_id.includes('HOT')
      const bHasHot = b.brand_game_category_id.includes('HOT')

      // Prioritize 'NEW' over 'HOT'
      if (aHasNew && !bHasNew) {
        return -1 // 'NEW' comes first
      }
      if (!aHasNew && bHasNew) {
        return 1 // 'NEW' comes first
      }

      // Prioritize 'HOT' if neither has 'NEW'
      if (aHasHot && !bHasHot) {
        return -1 // 'HOT' comes first
      }
      if (!aHasHot && bHasHot) {
        return 1 // 'HOT' comes first
      }

      // Fallback to sorting by recommend_sort
      return a.recommend_sort - b.recommend_sort
    },
    showAllGame(game) {
      this.isFirstRender = false
      this.allGameData = []
      this.selectedCategoryGame = []

      if (game.id === -1) {
        this.$store.commit('SET_ACTIVE_FILTER', 'favorites')
      } else {
        game.attribute = 'category'
        this.$store.commit('SET_CURRENT_GAME_CATEGORY', game)
      }

      this.$nextTick(() => {
        this.gameScroll('gameCategory', 'gameCategory', 20, 135)
      })
    },
    getCatagoryList() {
      if (this.token && (this.favoriteAll.length > 0)) {
        const customItem = {
          image_banner: getThemeImagePath('icon_tab_favorite.png'),
          isFavGame: true
        }
        this.catagoryList = [customItem, ...this.gameCategory]
      } else {
        this.catagoryList = this.gameCategory
      }
    },
    getCatagoryGame() {
      if (this.token && this.favoriteGamesId.length > 0) {
        const updatedCategory = [...this.gameCategory]
        const customItem = {
          id: -1,
          name: this.$t('Bao.my_favorite')
        }
        updatedCategory.unshift(customItem)
        this.catagoryGame = updatedCategory
      } else {
        this.catagoryGame = this.gameCategory
      }
    },
    prev(categoryId) {
      let container = ''
      let cardWidth = ''

      if (categoryId !== 'event') {
        const key = categoryId < 0 ? 'fav' : categoryId.toString()
        container = this.$refs[`carousel-${key}`]
        cardWidth = this.cardWidth
      } else {
        container = this.$refs['carousel-event']
        cardWidth = 290
      }

      const element = Array.isArray(container) ? container[0] : container
      if (!element) return false
      const scrollStep = cardWidth + this.actualGap

      element.scrollTo({
        left: element.scrollLeft - scrollStep,
        behavior: 'smooth'
      })
    },
    next(categoryId) {
      let container = ''
      let cardWidth = ''

      if (categoryId !== 'event') {
        const key = categoryId < 0 ? 'fav' : categoryId.toString()
        container = this.$refs[`carousel-${key}`]
        cardWidth = this.cardWidth
      } else {
        container = this.$refs['carousel-event']
        cardWidth = 290
      }

      const element = Array.isArray(container) ? container[0] : container
      if (!element) return false
      const scrollStep = cardWidth + this.actualGap

      element.scrollTo({
        left: element.scrollLeft + scrollStep,
        behavior: 'smooth'
      })
    },
    canScrollPrev(categoryId) {
      let container = ''
      if (categoryId !== 'event') {
        const key = categoryId < 0 ? 'fav' : categoryId.toString()
        container = this.$refs[`carousel-${key}`]
      } else {
        container = this.$refs['carousel-event']
      }

      const element = Array.isArray(container) ? container[0] : container
      if (!element) return false
      return element.scrollLeft > 0
    },
    canScrollNext(categoryId) {
      let container = ''
      if (categoryId !== 'event') {
        const key = categoryId < 0 ? 'fav' : categoryId.toString()
        container = this.$refs[`carousel-${key}`]
      } else {
        container = this.$refs['carousel-event']
      }

      const element = Array.isArray(container) ? container[0] : container
      if (!element) return false
      return element.scrollLeft < (element.scrollWidth - element.clientWidth)
    },
    // 滾動到第一筆
    resetScrollToStart(categoryId) {
      const key = categoryId < 0 ? 'fav' : categoryId.toString()
      const container = this.$refs[`carousel-${key}`]
      const element = Array.isArray(container) ? container[0] : container
      if (!element) return

      element.scrollTo({
        left: 0,
        behavior: 'smooth'
      })
    },
    isGameFavorite(gameId) {
      return this.favoriteGamesId.some(fav => fav.game_id === gameId)
    },
    checkGameLength(currentGames) {
      const validGames = Array.isArray(currentGames) && currentGames.filter(game => game.status === 1 && game.is_show === '1') || []
      if (currentGames.length >= 100 && validGames.length < 100) {
        return false
      } else {
        return true
      }
    },
    async fetchAllCategoryGames(categories) {
      const requests = categories.map(category => ({
        categoryId: category.id,
        promise: this.fetchGamesFromAPI({
          category: category.id,
          page: 1,
          page_size: this.page_size
        })
      }))

      return Promise.all(
        requests.map(request => this.processCategory(request))
      )
    },
    async processCategory(request) {
      try {
        let allGames = []
        let currentPage = 1
        let hasEnoughGames = false

        const firstPageGames = await request.promise

        if (!firstPageGames || !firstPageGames.list) {
          return {
            categoryId: request.categoryId,
            games: []
          }
        }

        allGames = [...firstPageGames.list]

        // 檢查是否需要獲取更多數據
        if (this.checkGameLength(allGames)) {
          hasEnoughGames = true
        }

        // 如果第一頁數據不夠，繼續獲取更多頁
        currentPage = 2 // 從第二頁開始
        while (!hasEnoughGames) {
          const games = await this.fetchGamesFromAPI({
            category: request.categoryId,
            page: currentPage,
            page_size: this.page_size
          })

          if (!games || !games.list) {
            break
          }

          allGames = [...allGames, ...games.list]

          if (this.checkGameLength(allGames)) {
            hasEnoughGames = true
          } else {
            currentPage++
          }
        }

        const processedGames = allGames
          .slice(0, 100)
          .sort(this.sortGames)
          .map(game => ({
            ...game,
            isFavorite: this.isGameFavorite(game.id)
          }))

        return {
          categoryId: request.categoryId,
          games: processedGames
        }
      } catch (error) {
        console.error(`Error processing category ${request.categoryId}:`, error)
        return {
          categoryId: request.categoryId,
          games: []
        }
      }
    },
    getProviderImage(providerId) {
      const provider = this.$store.state.game.gameSideBarProvider.find(
        provider => provider.game_provider_id === providerId
      )
      return provider ? provider.image_h5 : ''
    },
    startMarquee() {
      if (this.isRunning) return
      this.isRunning = true

      const moveText = () => {
        if (!this.isRunning) return
        this.positionX -= this.speed

        if (this.positionX <= -this.$refs.marqueeContainer.scrollWidth) {
          this.positionX = this.$refs.marqueeContainer.offsetWidth
        }

        this.animationFrameId = requestAnimationFrame(moveText)
      }

      moveText()
    },
    stopMarquee() {
      this.isRunning = false
      cancelAnimationFrame(this.animationFrameId)
    },
    goNewsPage(key) {
      if (key) {
        this.$store.commit('SET_CHOOSE_NEWS', key)
      }
      this.$router.push({ path: '/user/news' })
    },
    // 被選中的遊戲標籤要移動至畫面中
    scrollToActive(refName) {
      this.$nextTick(() => {
        if (refName !== 'gameCategory') {
          const container = this.$refs[refName]
          const activeItem = container.querySelector('.active')
          if (activeItem) {
            const containerRect = container.getBoundingClientRect()
            const activeItemRect = activeItem.getBoundingClientRect()
            let scrollPosition
            if (activeItem === container.lastElementChild) {
              scrollPosition = container.scrollWidth - container.clientWidth
            } else {
              scrollPosition = activeItemRect.left - containerRect.left + container.scrollLeft - (containerRect.width / 2) + (activeItemRect.width / 2)
            }
            container.scrollLeft = scrollPosition
          }
        } else {
          const slickInstance = this.$refs.slickCarousel
          const activeIndex = this.catagoryList.findIndex(item => this.isGameCategoryActive(item))
          slickInstance.goTo(activeIndex)
        }
      })
    },
    gameScroll(labelName, refName, web, mobile) {
      this.scrollToActive(labelName)
      this.$nextTick(() => {
        const activeFilter = this.$refs[refName]
        if (activeFilter) {
          let offset = web
          if (detectMob()) {
            offset = mobile
          }
          const top = activeFilter.getBoundingClientRect().top + window.scrollY - offset
          window.scrollTo({ top, behavior: 'smooth' })
        }
      })
    },
    updateWorkHour(newValue) {
      this.workHourVal = newValue
      updateCountUp('workHour', newValue)
    },
    callDailyPopup() {
      if (this.$store.getters.permissionInfo.pop_announcement_image) {
        const currentTimeStamp = Math.floor(Date.now() / 1000)
        const storedTimeStamp = localStorage.getItem('lastCommercialTimeStamp')
        if (storedTimeStamp) {
          if (isCrossDay(currentTimeStamp, parseInt(storedTimeStamp, 10))) {
            localStorage.setItem('lastCommercialTimeStamp', currentTimeStamp.toString())
            showAd(this.$store.getters.permissionInfo.pop_announcement_image, this.$store.state.brand.permissionInfo.pop_announcement_url, this.$store.state.brand.permissionInfo.pop_announcement_url_open_type)
          }
        } else {
          localStorage.setItem('lastCommercialTimeStamp', currentTimeStamp.toString())
          showAd(this.$store.getters.permissionInfo.pop_announcement_image, this.$store.state.brand.permissionInfo.pop_announcement_url, this.$store.state.brand.permissionInfo.pop_announcement_url_open_type)
        }
      }
    },
    isMobile() {
      return detectMob()
    },
    handleClick(banner_url, open_type) {
      const id = banner_url.match(/eventId=(\d+)/)[1] || banner_url.split('/').pop()

      switch (open_type) {
        case 'self':
          this.$router.push({ path: '/event', query: { eventId: id }})
          break

        case 'iframe':
          this.$store.commit('SET_GAME_URL', banner_url)
          break

        case 'new':
          window.open(banner_url, '_blank')
          break

        default:
          this.$router.push({ path: '/event', query: { eventId: id }})
      }
    },
    async handleFavoriteGame(game) {
      const gameInfo = {
        type: 'game',
        data: JSON.stringify([{
          brand_id: this.user.goldInfo.brand_id,
          game_id: game.id
        }])
      }
      try {
        const response = game.isFavorite
          ? await removeFavoriteGame(gameInfo)
          : await addFavoriteGame(gameInfo)

        this.$store.commit('SET_FAVORITE_GAME', response.data.data.game)
        this.showToast(game, !game.isFavorite)

        await this.updateFavoriteAll(this.favoriteGamesId)
        if (this.currentGameCategory || this.currentGameType || this.currentGameProvider) {
          this.selectedCategoryGame = this.sortCategoryGames(this.selectedCategoryGame)
        } else {
          const groupedFavoriteGames = {
            '-1': this.favoriteAll
          }
          this.allCategoryGame = {
            ...this.sortAllCategoryGames(this.allCategoryGame),
            ...groupedFavoriteGames
          }
          this.getCatagoryGame()
          this.resetScrollToStart('-1')
        }
        this.carouselKey += 1
      } catch (error) {
        console.error(error)
      }
    },
    showToast(game, isFavorite) {
      const message = isFavorite ? `${game.name} ${this.$t('Bao.favorite')}` : `${game.name} ${this.$t('Bao.favorite_remove')}`
      showToast(message)
      setTimeout(() => {
        this.$store.commit('SET_TOAST_MESSAGE', null)
      }, 3000)
    },
    async updateFavoriteAll(favorArr) {
      let gamesData = []
      const favoriteGameIds = new Set(favorArr.map(favGame => favGame.game_id))
      const gamesArr = Array.from(favoriteGameIds)
      await getGameList({ game_id_list_string: JSON.stringify(gamesArr) })
        .then((response) => {
          gamesData = response.data.data
        })
        .catch((err) => {
          console.log(err)
        })
      const processedGames = gamesData
        .filter(game => game.status === 1)
        .sort(this.sortGames)
        .map(game => {
          return {
            ...game,
            isFavorite: favoriteGameIds.has(game.id)
          }
        })

      this.favoriteAll = processedGames
      this.favoriteAll.attribute = 'favorites'

      if (this.activeFilter === 'favorites') {
        this.selectedCategoryGame = this.favoriteAll
      }

      this.getCatagoryList()

      if (this.isFirstRender) {
        return
      }

      if (this.isFromBack) {
        this.isFromBack = false
      } else {
        this.navigationHistory.push({ attribute: 'favorites' })
      }
    },
    initializeCountUp,
    getGameNum() {
      getGameNum().then((response) => {
        this.$store.commit('SET_GAME_NUM', response.data.num)
        this.updateWorkHour(response.data.num)
      })
        .catch((err) => {
          console.log(err)
        })
    },
    refreshProvider(gameType) {
      this.allProvider = []
      for (const i in this.allType) {
        const index = this.allType[i].game_type
        this.allProvider[index] = this.allType[i].providers
      }
      this.allProvider[gameType].sort((a, b) => a.sort - b.sort)
      this.$store.commit('SET_GAME_PROVIDER', this.allProvider[gameType])
    },
    getProviderNum(gameType) {
      getProviderNum().then((response) => {
        const gameSum = this.getGameSum(response.data.provider_list_num[gameType])
        this.$store.commit('SET_GAME_NUM', gameSum)
        this.updateWorkHour(gameSum)
      })
        .catch((err) => {
          console.log(err)
        })
    },
    getGameSum(gameData) {
      var totalNum = gameData.reduce((sum, game) => sum + game.num, 0)
      return totalNum
    },
    async fetchGamesFromAPI(queryObj) {
      const response = await getGames(queryObj)
      return response.data.data || []
    },
    async handleLaunchGame(game) {
      await gameStart('game', game)
    },
    checkTokenExpiration() {
      setInterval(() => {
        if (localStorage.getItem('token')) {
          const expiredTime = localStorage.getItem('expired_time')
          if (!expiredTime || new Date().getTime() > expiredTime) {
            this.updateToken()
          }
        }
      }, 60000)
    },
    updateToken() {
      if (localStorage.getItem('token')) {
        updateToken({ token: localStorage.getItem('token') }).then(response => {
          const tokenData = response.data.data.token
          const expiredTime = new Date().getTime() + (tokenData.expired_interval * 1000)
          localStorage.setItem('expired_time', expiredTime)
          localStorage.setItem('token', tokenData.token)
        }).catch(error => {
          console.error('Error updating token', error)
        })
      }
    },
    async getAllGameForSearch() {
      const response = await getGames({ showLoading: false })
      this.allGame = response.data.data.list
      this.$store.commit('SET_ALL_GAME', this.allGame)
    },
    isGameCategoryActive(item) {
      if (this.activeFilter === 'favorites' && item.isFavGame) return true
      // Check if the currently active filter matches the given category
      if (this.activeFilter === 'others' && this.currentGameCategory && this.currentGameCategory.id === item.id) {
        return true
      }
      return false
    },
    changeGameType(item) {
      this.isFirstRender = false
      this.$store.commit('SET_CURRENT_GAME_CATEGORY', null)
      this.$store.commit('SET_CURRENT_GAME_PROVIDER', null)
      this.$store.commit('SET_ACTIVE_FILTER', 'others')
      item.attribute = 'type'
      this.$store.commit('SET_CURRENT_GAME_TYPE', item)
    },
    changeGameCategory(item) {
      const filterValue = item.isFavGame ? 'favorites' : 'others'

      if (filterValue === 'favorites') {
        this.$store.commit('SET_CURRENT_GAME_CATEGORY', null)
      } else {
        item.attribute = 'category'
        this.$store.commit('SET_CURRENT_GAME_CATEGORY', item)
      }

      this.$store.commit('SET_CURRENT_GAME_TYPE', null)
      this.$store.commit('SET_CURRENT_GAME_PROVIDER', null)
      this.$store.commit('SET_ACTIVE_FILTER', filterValue)
    },
    changeGameProvider(item) {
      this.$store.commit('SET_CURRENT_GAME_CATEGORY', null)

      item.attribute = 'provider'
      this.$store.commit('SET_CURRENT_GAME_PROVIDER', item)
      this.$store.commit('SET_ACTIVE_FILTER', 'others')
    },
    ...mapMutations(['SET_SHOW_RESEARCH', 'SET_SHOW_PROVIDER']),
    showSearchProvider() {
      this.$store.commit('SET_SHOW_PROVIDER', true)
      this.$store.commit('SET_SHOW_RESEARCH', false)
    },
    showSearchGame() {
      this.$store.commit('SET_SHOW_RESEARCH', true)
      this.$store.commit('SET_SHOW_PROVIDER', false)
    },
    isGameTypeActive(item) {
      if (this.currentGameType && this.currentGameType.id === item.id) {
        return true
      }
      return false
    },
    openDemoGame(game) {
      this.$store.commit('SET_GAME_URL', game.demo_url)
    },
    getThemeImagePath,
    clearQuery() {
      if (Object.keys(this.$route.query).length > 0) {
        this.$router.replace({ query: {}})
      }
    }
  }
}
</script>
<style>
.slick-div .slick-prev:before, .slick-div .slick-next:before {
  content: ''
}
.slick-div .slick-prev {
  top: 42%;
  display: flex;
  left: -10px;
  width: 60px;
  align-items: center;
}
.slick-div .slick-next {
  top: 42%;
  display: flex;
  right: -10px;
  width: 60px;
  align-items: center;
}
.provider-container .slick-prev:before, .provider-container .slick-next:before {
  content: ''
}
.provider-container .slick-prev {
  display: flex;
  left: -11px;
  align-items: center;
  width: 30px;
  z-index: 2;
}
.provider-container .slick-next {
  display: flex;
  right: -11px;
  width: 30px;
  align-items: center;
}
:not(.provider-container .slick-list) >.slick-track[data-v-e4caeaf8] {
  position: relative;
  top: calc(50% - 46%);
  left: 0;
  display: block;
  -webkit-transform: translateZ(0);
  transform: translateZ(0);
}
@media (max-width: 1400px) {
  :not(.provider-container .slick-list) >.slick-track[data-v-e4caeaf8] {
    top: calc(50% - 50%);
  }
}
@media (max-width: 1300px) {
  :not(.provider-container .slick-list) >.slick-track[data-v-e4caeaf8] {
    top: calc(50% - 48%);
  }
}
@media (max-width: 1200px) {
  :not(.provider-container .slick-list) >.slick-track[data-v-e4caeaf8] {
    top: calc(50% - 40%);
  }
}
@media (max-width: 1100px) {
  :not(.provider-container .slick-list) >.slick-track[data-v-e4caeaf8] {
    top: calc(50% - 40%);
  }
}
@media (max-width: 1000px) {
  :not(.provider-container .slick-list) >.slick-track[data-v-e4caeaf8] {
    top: calc(50% - 37%);
  }
}

.provider-container .jp-slick-arrow img {
  min-width: 0;
}

:not(.provider-container .slick-list) >.slick-initialized .slick-slide[data-v-e4caeaf8] {
  justify-content: center;
}

</style>
